import { Box, Button, Card, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Page from 'app/layout/Page'

export interface SuperAdminEngagementResourcesEditFormProps {
  linkValue: string
  onLinkChange: (value: string) => void
  onCancel: () => void
  onSave: () => void
  isSaving: boolean
  isSaveDisabled: boolean
}

export const SuperAdminEngagementResourcesEditForm = ({
  linkValue,
  onLinkChange,
  onCancel,
  onSave,
  isSaving,
  isSaveDisabled,
}: SuperAdminEngagementResourcesEditFormProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'engagementResourcesPage' })

  return (
    <Page>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h1" data-testid="engagement-resources-edit-title">
          {t('editTitle')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <Button
            variant="outlined"
            onClick={onCancel}
            disabled={isSaving}
            data-testid="engagement-resources-cancel-button"
            sx={{
              height: 40,
              color: '#373736',
              borderColor: '#373736',
              '&:hover': { borderColor: '#373736', backgroundColor: 'transparent' },
            }}
          >
            {t('freeResources.cancel')}
          </Button>
          <Button
            variant="contained"
            onClick={onSave}
            disabled={isSaveDisabled}
            data-testid="engagement-resources-save-button"
          >
            {t('freeResources.save')}
          </Button>
        </Box>
      </Box>
      <Card
        sx={{
          display: 'flex',
          padding: '20px 16px',
          alignItems: 'center',
          gap: '120px',
          alignSelf: 'stretch',
          boxShadow: '0 2px 4px 0 rgba(188, 188, 188, 0.50)',
        }}
      >
        <Typography variant="subtitle2" sx={{ whiteSpace: 'nowrap' }}>
          {t('freeResources.linkLabel')}
        </Typography>
        <TextField
          value={linkValue}
          onChange={(e) => onLinkChange(e.target.value)}
          variant="outlined"
          size="small"
          slotProps={{ htmlInput: { 'data-testid': 'engagement-resources-link-input' } }}
          sx={{ width: 320 }}
        />
      </Card>
    </Page>
  )
}
